import { render, staticRenderFns } from "./WidgetBookingResumeWithFlights.vue?vue&type=template&id=33faa88d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./WidgetBookingResumeWithFlights.vue?vue&type=script&lang=js"
export * from "./WidgetBookingResumeWithFlights.vue?vue&type=script&lang=js"
import style0 from "./WidgetBookingResumeWithFlights.vue?vue&type=style&index=0&id=33faa88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33faa88d",
  null
  
)

export default component.exports